function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.12 6.93a9.15 9.15 0 00-1.51 1.9.24.24 0 00.06.23c.47.4 1 .76 1.42 1.16A23.94 23.94 0 0114.93 12a1.77 1.77 0 01.32 1.86 10.07 10.07 0 01-1.49 2.6l-.79 1a1.25 1.25 0 01-.82.49 1.3 1.3 0 01-1-.2 1.16 1.16 0 01-.23-1.7c.57-.79 1.13-1.6 1.68-2.41.26-.4.24-.43-.13-.75-.83-.72-1.7-1.42-2.55-2.13a2 2 0 01-.81-2.48 7 7 0 011.59-2.42c.49-.52 1-1 1.55-1.5a1.3 1.3 0 012 .15 6.11 6.11 0 003.46 2.17 6.64 6.64 0 001 .1 1.28 1.28 0 011.29.9A1.09 1.09 0 0119.39 9a2 2 0 01-.84.18 8.12 8.12 0 01-5.18-2L13.21 7h-.09zM16 0a2 2 0 11-2 2 2 2 0 01.58-1.41A2 2 0 0116 0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "biking_svg__a",
  d: "M21.12 14.29a4.88 4.88 0 01.93-.09 5 5 0 014.07 2.11 4.87 4.87 0 01.57 4.51 5 5 0 01-3.42 3 5 5 0 01-4.47-1.02 4.87 4.87 0 01.88-8l-.14-.8a21.69 21.69 0 00-3.78-.09L15 12.47a24.47 24.47 0 014.28 0l-.21-1.21 1.48-.26zm-2.27 6.12a3.46 3.46 0 003.2 2.12 3.42 3.42 0 001.32-6.59 3.5 3.5 0 00-3.77.74 3.39 3.39 0 00-.75 3.73zM2.28 14.71a5.4 5.4 0 015-.53 25.19 25.19 0 013-1.18l.72 1.39c-.74.22-1.46.48-2.17.77a5 5 0 011.62 4.57 5.13 5.13 0 01-3 3.82 5.43 5.43 0 01-5-.34 5 5 0 01-.16-8.5zm-.39 5.56a3.66 3.66 0 003.38 2.19 3.61 3.61 0 003.66-3.55 3.54 3.54 0 00-2.26-3.28 3.74 3.74 0 00-4 .77 3.46 3.46 0 00-.78 3.87z"
});

function SvgBiking(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 27 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "assets/images/biking.546cbfe7.svg";
export { SvgBiking as ReactComponent };